import { Inject, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import {
  APPLICATION_INSIGHTS_CONFIG,
  ApplicationInsightsConfig,
} from './application-insights.model';
import { AppMonitoring } from './app-monitoring.model';

@Injectable()
export class ApplicationInsightsMonitoringService implements AppMonitoring {
  appInsights!: ApplicationInsights;

  constructor(
    @Inject(APPLICATION_INSIGHTS_CONFIG) config: ApplicationInsightsConfig
  ) {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: config.connectionString,
        enableAutoRouteTracking: config.enableAutoRouteTracking,
        disableTelemetry: config.disableTelemetry,
      },
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(
    name: string,
    average: number,
    properties?: { [key: string]: any }
  ) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}
